import React, {useState} from 'react';

import {AddCouponDiscount} from '../../../../AddCouponDiscount';
import {CouponDiscount} from '../../../../CouponDiscount';

import {
  Container,
  HelpButtonCircle,
  HelpButtonIcon,
  SectionHeader,
  Title,
} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';
import {PedidoDTO} from '../../../../../../dtos/PedidoDTO';
import {Discount, Localidade} from '../..';
import {useNavigation} from '@react-navigation/native';
import {HelpVideo} from '../../../../HelpVideo';
import analytics from '@react-native-firebase/analytics';

type Props = {
  pedidos: PedidoDTO;
  discount: Discount;
  localidade: Localidade;
  isGnv?: boolean;
};

const VIDEO_URL = 'https://d3ag5cip9ldvh3.cloudfront.net/APLICARCUPOM.mp4';

export function CheckoutDiscountCoupon({
  pedidos,
  discount,
  localidade,
  isGnv = false,
}: Props) {
  const navigation = useNavigation();

  const [showHelpCouponVideo, setShowHelpCouponVideo] = useState(false);

  function onRemoveDiscount() {
  analytics().logEvent('checkout_removeu_cupom');
  navigation.setParams({
    discount: undefined,
    coupon: undefined,
  });
}

  return (
    <>
      <Container>
        <SectionHeader
          style={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginBottom: RFValue(6),
          }}>
          <Title style={{marginBottom: 0}}>Cupom de desconto</Title>

       <HelpButtonCircle
  onPress={() => {
    analytics().logEvent('checkout_abriu_video_ajuda_cupom');
    setShowHelpCouponVideo(true);
  }}>
            <HelpButtonIcon name="help-circle-outline" />
          </HelpButtonCircle>
        </SectionHeader>

        {!discount ? (
          <AddCouponDiscount
            fluxoNovo
            pedidos={pedidos}
            localidade={localidade}
            gnv={isGnv}
          />
        ) : (
          <CouponDiscount
            pedidos={pedidos}
            discount={discount}
            localidade={localidade}
            gnv={isGnv}
            onRemoveDiscount={onRemoveDiscount}
          />
        )}
      </Container>
      {showHelpCouponVideo && (
        <HelpVideo
          videoURI={VIDEO_URL}
          onVideoEnd={() => setShowHelpCouponVideo(false)}
        />
      )}
    </>
  );
}
